import { render, staticRenderFns } from "./InheritLayout.vue?vue&type=template&id=244d183d&scoped=true"
import script from "./InheritLayout.vue?vue&type=script&lang=js"
export * from "./InheritLayout.vue?vue&type=script&lang=js"
import style0 from "./InheritLayout.vue?vue&type=style&index=0&id=244d183d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d183d",
  null
  
)

export default component.exports